

import _ from 'lodash';

;
import SirTrevor from 'sir-trevor';
export default (function(){

  const paste_template = `
    <input type="text" placeholder="Paste IFrame here" class="st-block__paste-input st-paste-block">
  `;

  const editor_template = data => {
    return (
      `
      <div class="st-controllable-block">
        <div class="st-controllable-block__content">
          <iframe width="${data.width}" height="${data.height}" frameborder="0" scrolling="${data.scrolling}" marginheight="0" marginwidth="0" src="${data.src}"></iframe>
          <div class="st-controllable-block__meta-row">
            <label for="width" class="st-image__meta-item-label">Width</label>
            <input type="text" class="paste-block st-required" value="${data.width}" name="width" />
          </div>
          <div class="st-controllable-block__meta-row">
            <label for="height" class="st-image__meta-item-label">Height</label>
            <input type="text" class="paste-block st-required" value="${data.height}" name="height" />
          </div>
          <div class="st-controllable-block__meta-row">
            <label for="source" class="st-image__meta-item-label">Source</label>
            <input type="text" class="paste-block st-required" value="${data.src}" name="source" />
          </div>
          <div class="st-controllable-block__meta-row">
            <label for="source" class="st-image__meta-item-label">Scroll enabled</label>
            <input type="checkbox" class="paste-block st-required" ${data.scrolling == "yes" ? "checked=\"checked\"" : ""} name="scrolling" />
          </div>
        </div>
        <div class="st-controllable-block__footer">Iframe</div>
      </div>`
    );
  };

  return SirTrevor.Block.extend({

    type: "iframe",
    title: () => "Iframe",
    pastable: true,
    paste_options: {
      html: paste_template
    },
    icon_name: 'iframe',

    loadData: function(data) {
      this.renderUi(data);
    },

    onBlockRender: function() {
      $(this.editor).on(
        "keyup change", ".paste-block", this.on_iframe_change.bind(this)
      );
    },

    on_iframe_change: function() {
      this.update_iframe(this._get_iframe_data());
    },

    _get_iframe_data: function() {
      return {
        width : $(this.editor).find('input[name=width]').val(),
        height : $(this.editor).find('input[name=height]').val(),
        src : $(this.editor).find('input[name=source]').val(),
        scrolling : ($(this.editor).find('input[name=scrolling]').prop("checked") ? "yes":"no"),
      };
    },

    _serializeData: function() {
      return this._get_iframe_data();
    },

    update_iframe: function(data) {
      $(this.editor).find("iframe").width(data.width).height(data.height).attr('src', data.src).attr('scrolling', data.scrolling);
    },

    onContentPasted: function(event){
      var html = event.target.value;

      if(!this.validateIframe(html)) { return false; }

      var iframe = this.clean_iframe(html);

      var data = {
        scrolling: iframe.attr('scrolling'),
        src: iframe.attr('src'),
        width: iframe.width() || iframe.attr('width'),
        height: iframe.height() || iframe.attr('height')
      };

      this.setData(data);
      this.render_iframe(data);

      this.ready();
    },

    renderUi: function(data) {
      $(this.editor).html(editor_template(data)).show();
    },

    render_iframe: function(data) {
      this.renderUi(data);
      $(this.inputs).hide();
      $(this.el).show();
    },

    validateIframe: function(html) {
      return html.search(/iframe/) !== -1;
    },

    clean_iframe: function(html) {
      html = $(html);
      return (html.length > 1) ? html.filter("iframe").first() : html;
    },

    focus: function() {
      this.inner.querySelector('.st-block__paste-input').focus();
    }

  });

})();
